// @ts-check

/** @file Shared sizing metrics for single-line form controls. */

/** Border radius shared by single-line form controls. */
export const FORM_CONTROL_BORDER_RADIUS = 10

/** Border width shared by single-line form controls. */
export const FORM_CONTROL_BORDER_WIDTH = 1

/** Font size shared by single-line form controls. */
export const FORM_CONTROL_FONT_SIZE = 14

/** Line height shared by single-line form controls. */
export const FORM_CONTROL_LINE_HEIGHT = 20

/** Horizontal padding shared by single-line form controls. */
export const FORM_CONTROL_PADDING_HORIZONTAL = 12

/** Vertical padding shared by single-line form controls. */
export const FORM_CONTROL_PADDING_VERTICAL = 10
